<template>

    <div class="container">

        <app-head title="Brands" />

        <div class="my-4">
            <h1>{{ __('Brands') }}</h1>
        </div>
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-5 g-3">

            <div class="col" v-for="brand in brands.data">
                <div class="card h-100">
                    <img class="card-img-top" :src="brand.logo" alt="" v-if="brand.logo" loading="lazy" />
                    <div class="card-body">
                        <h3 class="card-title h6 m-0">
                            <inertia-link :href="brand.permalink" class="stretched-link">
                                {{ brand.name }}
                            </inertia-link>
                        </h3>
                    </div>
                </div>
            </div>

        </div>

        <pagination :links="brands.meta.links" />

    </div>

</template>

<script>
    import Pagination from '@/shared/Pagination';
    import Breadcrumbs from '@/shared/Breadcrumbs';

    export default {
        props: [
            'brands'
        ],
        data() {
            return {
            }
        },
        components: {
            Pagination,
            Breadcrumbs,
        }
    }
</script>